/**
 * The wording of the shared-link lists (ADR-0084, DEV_SPEC-0084 Appendix A.6),
 * kept free of the DOM so Vitest can check it. Dates are German calendar
 * dates in German time, whatever the browser's zone.
 */

export function germanDate(iso) {
    return new Date(iso).toLocaleDateString('de-DE', { timeZone: 'Europe/Berlin' });
}

export function shareLine(share) {
    const noun = share.turn_count === 1 ? 'Frage' : 'Fragen';
    const expiry = share.expires_at
        ? `läuft ab am ${germanDate(share.expires_at)}`
        : 'unbefristet';
    return `${share.turn_count} ${noun} · erstellt am ${germanDate(share.created_at)} · ${expiry}`;
}

export const REVOKE_CONFIRMATION =
    'Diesen Link widerrufen? Wer ihn öffnet, sieht danach nur noch '
    + '‚Dieser Link ist nicht mehr gültig.‘';
export const EMPTY_CONVERSATION_LIST = 'Für diese Konversation gibt es keine Links.';
export const EMPTY_ACCOUNT_LIST = 'Sie haben keine Konversation geteilt.';

// The token of a pasted link (last path segment after /share/), or the
// input itself when it is a bare token (DEV_SPEC-0084 FR-40).
export function tokenFrom(input) {
    const value = input.trim();
    const match = value.match(/\/share\/([^/?#\s]+)/);
    return match ? match[1] : value;
}
